import { z } from "zod";
/** Constitution §4.7 + Tier 1 Master §18.4 responsibility statuses. */
export const ResponsibilityStatusV1Schema = z.enum([
    "PASSED",
    "FAILED",
    "BLOCKED",
    "CLIENT_NOT_PROVIDED",
    "CLIENT_DECLINED",
    "CLIENT_UNRESPONSIVE",
    "AGENCY_DEFERRED",
    "AGENCY_SKIPPED",
    "MANAGER_APPROVED_EXCEPTION",
    "POLICY_DISABLED",
    "NOT_APPLICABLE",
]);
//# sourceMappingURL=responsibility-status.js.map